import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0a5fdd6a&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/modules/header.scss?vue&type=style&index=0&id=0a5fdd6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5fdd6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jin_macintosh/Documents/www.nosync/yusuugaku/web/public/wp-content/themes/ysk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5fdd6a')) {
      api.createRecord('0a5fdd6a', component.options)
    } else {
      api.reload('0a5fdd6a', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=0a5fdd6a&scoped=true&", function () {
      api.rerender('0a5fdd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/Header.vue"
export default component.exports